// extracted by mini-css-extract-plugin
export default {"grid":"DesktopIcons_grid__YyfWM","icon":"DesktopIcons_icon__gdxW9","iconImage":"DesktopIcons_iconImage__0ryQM","label":"DesktopIcons_label__NEDhE"};